import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function AISurfaces() {
  const page = getSemanticPageByPath('/ai-surfaces');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
